import { ImplementationRequestButtonComponent } from '../components';
import { LimitService } from '../services';
import { shouldHideImplementationButton } from '../utils';

/**
 * Manages the implementation request button in the header
 *
 * This manager is responsible for:
 * - Showing/hiding the button based on limiting state
 * - Updating the button when page content changes
 * - Attaching event handlers
 */
export class ImplementationButtonManager {
  private buttonComponent = new ImplementationRequestButtonComponent();
  private limitService = new LimitService();
  private auditName: string = '';

  /**
   * Initialize the manager with audit name
   * @param auditName - The name of the audit
   */
  initialize(auditName: string): void {
    this.auditName = auditName;
  }

  /**
   * Update the header with implementation request button
   * @param actionsCount - Total number of actions available
   */
  update(actionsCount: number): void {
    // Remove any existing button
    this.removeButton();

    // Add button to header if we're limiting results and have actions
    if (this.shouldShowButton(actionsCount)) {
      this.addButton();
      this.attachHandlers();
    }
  }

  /**
   * Determine if button should be shown
   * @param actionsCount - Total number of actions
   * @returns True if button should be displayed
   */
  private shouldShowButton(actionsCount: number): boolean {
    if (shouldHideImplementationButton()) return false;
    return this.limitService.shouldLimitRecommendationResults() && actionsCount > 0;
  }

  /**
   * Add button to header
   */
  private addButton(): void {
    const header = document.querySelector('header');
    if (header) {
      header.insertAdjacentHTML('beforeend',
        this.buttonComponent.render(this.auditName, 'header')
      );
    }
  }

  /**
   * Remove existing button from DOM
   */
  private removeButton(): void {
    const existingButton = document.querySelector('.header-implementation-request-button-container');
    if (existingButton) {
      existingButton.remove();
    }
  }

  /**
   * Attach event handlers to button
   */
  private attachHandlers(): void {
    this.buttonComponent.attachHandlers();
  }
}
